import React, { useMemo, useState } from "react";
import { Icon } from "@iconify/react";
import { getInitials } from "../../../utils/whatsappFormat";
import SaveContactModal from "./SaveContactModal";

/** Compact phone display matching whatsCRM: +916355054424 */
function formatCompactPhone(digits) {
  const raw = String(digits || "").replace(/\D/g, "");
  if (!raw) return "";
  if (raw.length === 10) return `+91${raw}`;
  if (raw.length === 12 && raw.startsWith("91")) return `+${raw}`;
  if (raw.startsWith("+")) return String(digits);
  return `+${raw}`;
}

export default function ContactInfoCard({
  chatId,
  senderName,
  senderMobile,
  contact,
  onContactSaved,
}) {
  const [showSave, setShowSave] = useState(false);

  const name =
    String(contact?.name || "").trim() ||
    String(senderName || "").trim() ||
    formatCompactPhone(senderMobile) ||
    chatId ||
    "—";
  const mobileRaw = contact?.mobile || senderMobile || chatId || "";
  const phoneLabel = formatCompactPhone(mobileRaw);
  const isSaved = contact?.isSaved === true;

  const initialVars = useMemo(
    () => ({
      var1: contact?.var1 || "",
      var2: contact?.var2 || "",
      var3: contact?.var3 || "",
      var4: contact?.var4 || "",
      var5: contact?.var5 || "",
    }),
    [contact],
  );

  return (
    <>
      <section className="wa-crm-contact-card">
        <div className="wa-crm-contact-avatar">{getInitials(name)}</div>
        <div className="wa-crm-contact-meta">
          <div className="wa-crm-contact-name">{name}</div>
          <div className="wa-crm-contact-phone">{phoneLabel || "—"}</div>
          {isSaved && contact?.phonebookName ? (
            <span className="wa-phonebook-chip">{contact.phonebookName}</span>
          ) : null}
        </div>
        <button
          type="button"
          className="wa-crm-contact-save"
          title={isSaved ? "Update contact" : "Save to phonebook"}
          aria-label={isSaved ? "Update contact" : "Save to phonebook"}
          onClick={() => setShowSave(true)}
        >
          <Icon icon="solar:diskette-bold" width={22} />
        </button>
      </section>

      <SaveContactModal
        show={showSave}
        onHide={() => setShowSave(false)}
        chatId={chatId}
        initialName={name !== "—" ? name : ""}
        initialMobile={mobileRaw}
        initialPhonebookId={contact?.phonebookId || ""}
        initialVars={initialVars}
        onSaved={onContactSaved}
      />
    </>
  );
}
